import { Plugin } from '@nuxt/types'

const translateWithParams: Plugin = (context, inject) => {
  inject('translateWithParams', (key: string, params: any[]): string => {
    // @ts-ignore
    const translation = context.app.i18n.t(key)
    // translation parameters replacement
    if (translation) {
      let index = 0
      return translation.replace(new RegExp('%\\d%|%s', 'g'), () => {
        const newString = index < params.length ? params[index] : ''
        index = index + 1
        return newString
      })
    }
    return translation
  })
}

export default translateWithParams
